import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IPromise, IScope} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {Debugger} from "debug";
import _ from "lodash";
import {WebNavigasjon} from "../../../../tjenester/WebNavigasjon";
import {MdDialogController} from "../../../../tjenester/Dialog";
import {MøteDatatjenesteForAjs} from "web/nedgraderteNg2Tjenester";
import {HttpEventType} from "@angular/common/http";
import {Subscription} from "rxjs";
import {omsluttLeveringIAjsApplyAsync} from "felles/ng2/rxjsHjelpere";
import {ng2RegNavn} from "web/nedgraderteNg2TjenesterRegisternavn";

const debug: Debugger = require('debug')('RegistrerEksterntSignertProtokollDialog');
require('./registrerEksterntSignertProtokollDialog.scss');


export class RegistrerEksterntSignertProtokollDialog implements MdDialogController {

    static visRegistrerEksterntSignertProtokollDialog($mdDialog: angular.material.IDialogService, møte: l.MøteModell): IPromise<void> {
        debug('visRegistrerEksterntSignertProtokollDialog', møte)
        return $mdDialog.show(this.dialogKonfigurasjon({moete: møte}));
    }

    private static dialogKonfigurasjon(locals: Object): angular.material.IDialogOptions {
        return {
            template: require('./registrerEksterntSignertProtokollDialog.html'),
            controller: RegistrerEksterntSignertProtokollDialog.forInjisering(),
            controllerAs: '$ctrl',
            bindToController: true,
            locals: locals
        };
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.md.$mdDialog,
            WebNavigasjon.regNavn,
            ng2RegNavn.MøteDatatjenesteForAjs,
            RegistrerEksterntSignertProtokollDialog
        ]
    }

    constructor(private $scope: IScope,
                private $mdDialog: angular.material.IDialogService,
                private navigasjon: WebNavigasjon,
                private møteDatatjenesteForAjs: MøteDatatjenesteForAjs) {
    }

    moete: l.MøteModell; //settes via locals

    modus: 'ikkepublisert' | 'velg' | 'lastOpp' | 'kvittering' = 'velg';
    progresjon = 0;

    private opplasting: Subscription;

    publiserProtokoll() {
        this.møteDatatjenesteForAjs.tjeneste().then(møteDatatjeneste =>
          møteDatatjeneste.oppdaterProtokollPublisering(this.moete.id, {erPublisert: true, sendMelding: false})
            .then(() => this.$scope.$evalAsync(() => this.modus = 'velg')));
    }

    lastOpp(filer: File[]) {
        if (_.isEmpty(filer)) return;
        debug('registrerEksterntSignertProtokoll', filer)
        this.modus = 'lastOpp';
        this.møteDatatjenesteForAjs.tjeneste().then(møteDatatjeneste => {
            this.opplasting = møteDatatjeneste.registrerEksterntSignertProtokoll(this.moete.id, filer[0])
              .pipe(omsluttLeveringIAjsApplyAsync(this.$scope))
              .subscribe({
                  next: event => {
                      if (event.type == HttpEventType.UploadProgress) this.progresjon = event.loaded;
                  },
                  error: e => this.modus = 'velg',
                  complete: () => this.modus = 'kvittering'
              })
        });
    }

    ferdig() {
        this.$mdDialog.hide();
        this.navigasjon.gåTilMøteProtokoll(this.moete.id);
    }

    avbryt() {
        if (this.opplasting) this.opplasting.unsubscribe();
        this.$mdDialog.cancel();
    }

    $onInit() {
        if (!this.moete.tilgang.erProtokollPublisert)
            this.modus = 'ikkepublisert';
        else
            this.modus = 'velg';
    }

    //private

}
